/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {useLocation, useNavigate} from 'react-router-dom'
import swal from 'sweetalert'
import {useTranslation} from 'react-i18next'
import { getDetailFileConfig } from 'src/api/modules/master-data/master'
import Skeleton from 'react-loading-skeleton'
import { useRoleUser } from 'src/hooks/useRoleUser'
import { getDashboardBanners } from 'src/api/modules/configuration/file'

const DashboardPage: FC = () => {
  const [loading, setLoading] = useState(false);
  const [imagesUrl, setImagesUrl] = useState<any>([])
  const [tab, setTab] = useState<any>(null)
  const {t} = useTranslation()

  const getTabLabel = (sectorId?: number) => {
    switch(sectorId) {
      case 1:
        return 'Domestik Korperasi'
      case 2:
        return 'Domestik Retail'
      case 3:
        return 'Export'
      case 4:
        return 'Agrosol'
      default:
        return 'information'
    }
  }

  const loadBanners = async () => {
    try{
      setLoading(true)

      let bannerTabs: any[] = [];
      const {data} = await getDashboardBanners()
      data?.data?.forEach((item: any) => {
        if(!bannerTabs.find((tab: any) => tab.sector_id === item.sector_id)) {
          bannerTabs.push({
            sector_id: item.sector_id,
            label: getTabLabel(item.sector_id),
            images: [{
              url: item.url_file,
              sort: item.sort
            }]
          })
        } else {
          const index = bannerTabs.findIndex((tab: any) => tab.sector_id === item.sector_id)
          bannerTabs[index].images.push({
            url: item.url_file,
            sort: item.sort
          })

          bannerTabs[index].images.sort((a: any, b: any) => a.sort - b.sort);
        }
      })
      bannerTabs.sort((a, b) => {
        if (a.label === 'information') return -1;
        if (b.label === 'information') return 1;
        return 0; // leave other order unchanged
      });
      if(bannerTabs.length > 0) {
        setTab(bannerTabs[0].label)
      }
      
      setImagesUrl(bannerTabs)
      setLoading(false)
    }catch(err:any) {
      setLoading(false)
    }
  }

  useEffect(() => {
    setLoading(true)
    setTimeout(() => {
      loadBanners()
    }, 500)
  }, [])

  return <>
    <div className='card'>
      <div className='card-body '>
        {loading ? (
          <Row>
            <Col md={6}>
              <Skeleton width={'100%'} height={250} />
            </Col>
            <Col md={6}>
              <Skeleton width={'100%'} height={250} />
            </Col>
          </Row>
        ) : (
          <>
            <ul className="nav nav-tabs">
              {
                imagesUrl.map((image: any, idx: number) => {
                  return (
                    <li className="nav-item" key={idx}>
                      <a onClick={() => setTab(image.label)} className={"nav-link " + ( tab == image.label ? "active px-4 bg-primary text-white font-weight-bold" : "")} style={{
                        fontSize: '18px'
                      }} data-toggle="tab" href={`#${idx}`}>{t(image.label)}</a>
                    </li>
                  )
                })
              }
            </ul>

            {imagesUrl.map((banner: any, idx: number) => {
                return (
                  <div className={'border p-4 ' + (tab == banner.label ? 'd-block' : 'd-none')} key={idx}>
                    <Row className='justify-content-space-between'>
                      { banner?.images?.map((image: any, index: number) => {
                        return <Col key={index} md={6} className='mb-4'>
                          { <img src={image.url} className='w-100 mb-2' alt='' /> }
                        </Col>
                      })}
                    </Row>
                  </div>
                )
            })}
            </>
          )}
      </div>
    </div>
  </>
}

const DashboardWrapper: FC = () => {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const {t} = useTranslation()

  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    sessionStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
  }

  const intl = useIntl()
  const location = useLocation();

  return (
    <>
      <PageTitle breadcrumbs={[]}>{t('DASHBOARD.TITLE')}</PageTitle>
      <DashboardPage key={location.pathname}/>
    </>
  )
}

export {DashboardWrapper}
